/**
 * DocumentSetEventEndDate
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EventEndDate from 'components/EventEndDate';

// Selectors
import { makeSelectDocumentSetValue } from 'services/documentSets/selectors';

interface Props {
    eventId?: number;
    prefix?: string;
}

export class DocumentSetEventEndDate extends React.PureComponent<Props> {
    render() {
        const { eventId, prefix } = this.props;
        if (!eventId) return null;
        return <EventEndDate eventId={eventId} prefix={prefix} />;
    }
}

const mapStateToProps = createStructuredSelector({
    eventId: makeSelectDocumentSetValue('eventId')
});

export default connect(mapStateToProps)(DocumentSetEventEndDate);
